import { useState } from 'react';
import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { MenuReorderDetailsDrawer } from '../menu-reorder-details-drawer';
import { useLastOrderAvailableToReorder } from '../use-last-order-available-to-reorder';

import { MenuReorderCard } from './index';

type MenuReorderCardProps = {
  openDetailEventMessage: string;
  isAvailable: () => boolean;
  logViewEvent: () => void;
  logReorderEvent: () => void;
  logOpenDetailEvent: () => void;
};

export const MenuReorderCardContainer = ({
  openDetailEventMessage,
  isAvailable,
  logViewEvent,
  logReorderEvent,
  logOpenDetailEvent,
}: MenuReorderCardProps) => {
  const lastOrder = useLastOrderAvailableToReorder();
  const [isDetailsDrawerOpen, setIsDetailsDrawerOpen] = useState<boolean>(false);
  const toggleDetailsDrawer = () => setIsDetailsDrawerOpen(!isDetailsDrawerOpen);

  if (!lastOrder || !isAvailable()) {
    return null; // or any fallback UI when the order is not available
  }

  return (
    <>
      {isDetailsDrawerOpen ? (
        <MenuReorderDetailsDrawer
          order={lastOrder}
          showDrawer={isDetailsDrawerOpen}
          toggleDetailsDrawer={toggleDetailsDrawer}
          openDetailEventMessage={openDetailEventMessage}
        />
      ) : (
        <Box padding="$4">
          <MenuReorderCard
            order={lastOrder}
            toggleDetailsDrawer={toggleDetailsDrawer}
            drawerIsOpen={isDetailsDrawerOpen}
            logViewEvent={logViewEvent}
            logReorderEvent={logReorderEvent}
            logOpenDetailEvent={logOpenDetailEvent}
          />
        </Box>
      )}
    </>
  );
};
